import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { sweetAlert } from '../../../utils/swal';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { ServiceAreasService } from '../../service-areas/service-areas-service/service-areas.service';
import { AssigTripsService } from '../../assigned-trips/assigntrips-service/assigntrips-service';
import { EQUIPMENTS, CAPACITY, FUELTYPES, BODYTYPES, nonZeroCoordinateValidator } from 'src/app/utils/utils.common';
import { LevelOfServiceService } from "../../level-of-service/service/level-of-service.service";
import { FleetService } from "../fleet-service/fleet.service";
import { ActivatedRoute, Router } from "@angular/router";
import { EquipmentService } from '../../equipments/equipment-service/equipment.service';
import { forkJoin } from 'rxjs';
import * as _ from 'underscore';

@Component({
  selector: "app-create-fleet",
  templateUrl: "./create-fleet.component.html",
  styleUrls: ["./create-fleet.component.css"],
})
export class CreateFleetComponent implements OnInit, OnDestroy {
fleetForm : UntypedFormGroup;
selectedStatus: any = "active";
user;
serviceAreas: any=[];
levelOfServices: any=[];
bodyType: any=[];
equipments:any = [];
capacity = CAPACITY;
fuelTypes = FUELTYPES;
bodyTypes = BODYTYPES;
fundingSources: any=[]
spaceTypes:any=[];
spaceTypesMain: any = [];
isSubmitted = false;
fleetId:any;
spaceTypeCapacity:any = []
status = "active"
preFundingSources = {};
fleetDetails;

  constructor(
    private fb: UntypedFormBuilder,
    private sharedDataService: SharedDataService,
    private serviceArea: ServiceAreasService,
    private assignTripService: AssigTripsService,
    private levelOfServiceService: LevelOfServiceService,
    private fleetService: FleetService,
    private equipment : EquipmentService,
    private activatedRoute: ActivatedRoute,
    private router : Router
  ) {}

  ngOnInit(): void {

    if (this.activatedRoute.snapshot.url.length === 4 && this.activatedRoute.snapshot.url[3].path === 'edit') {
      this.fleetId = this.activatedRoute.snapshot.url[2].path;
    }


    this.fleetForm = this.fb.group({
      setiDecall: ["", Validators.required],
      serviceAreas: [""],
      los: ["", Validators.required],
      losDetails: ["", Validators.required], // for payload only
      spaceType: ["",Validators.required],
      spaceTypeDetails: ["", Validators.required], // for payload only
      bodyType: ["", Validators.required],
      equipments: [""],
      capacity: ["", Validators.required],
      fundingSources: [[]],
      vin: ["", Validators.required],
      driverCarNumber: ["", Validators.required],
      realOdometer: [""],
      driverCarYear: ["", Validators.required],
      driverCarModel: ["", Validators.required],
      driverCarColor: ["", Validators.required],
      fuelType: ["", Validators.required],
      gasCardNumber: [""],
      limitation: [""],
      notes: [""],
      dimensions: this.fb.group({
        width: [""],
        height: [""],
        length: [""],
        groundClearance: [""],
        bedLength: [""],
        rampWidth: [""],
      }),
      owner: this.fb.group({
        name: [""],
        address: [""],
        latitude: [0, nonZeroCoordinateValidator(true)],
        longitude: [0, nonZeroCoordinateValidator(true)],
        phone: [""],
        business: [""],
        licenseNo: [""],
      }),

      capacities:  this.fb.array([]),
      status: ["active", Validators.required],
    });

    this.makeCompulsoryCalls();
  }

  makeCompulsoryCalls() {
    const requests = [
      this.getLevelOfService(),
      this.getSpaceTypeList(),
      this.getCorporateUserList()
    ];

    // Make all requests in parallel
    forkJoin(requests).subscribe(
      ([res1, res2, res3]) => {

        if (res1) {
          this.levelOfServices = res1;
        }
        if (res2) {
          this.spaceTypesMain = res2;
        }

        if (res3) {
          this.fundingSources = res3;
          this.preFundingSources = this.fundingSources.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }

        this.getServiceAreas();
        this.getCorporateUserList();
        this.getEquipments();
        this.getUser();
        this.getSpaceTypes();
      },
      error => {
        sweetAlert('Error', error, 'error', 'OK');
      }
    );
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          if(this.fleetId){
            this.getFleetbyId()
          }
        }
      });
  }

  getCorporateUserList() {
    const queryParams = {
      accountStatus: 'active'
    };
    if (this.fleetId) {
      queryParams['fleet'] = this.fleetId;
    }
    return this.assignTripService.getCredentialedCorporateUserList(queryParams);
  }

  getServiceAreas() {
    this.serviceArea
      .getServiceAreas({ status: "active" })
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.serviceAreas = data;
        }
      });
  }

  getLevelOfService() {

    return this.levelOfServiceService.getLevelOfServices({ status: 'active' });
  }

  getSpaceTypeList() {

    return this.levelOfServiceService.getSpaceTypes({ status: 'active' });
  }

  getSpaceTypes() {
    const queryParams = {
      status: this.status
    }

    this.levelOfServiceService
      .getSpaceTypes(queryParams)
      .subscribe(data => {
        if (data && data.length) {
          this.spaceTypeCapacity = data;
        } else {
          this.spaceTypeCapacity = [];
        }
      }, err => {
        sweetAlert("Error", err, "error", "Ok");
      });
  }

  getFleetbyId(){
    this.fleetService
      .getFleetDataById(this.fleetId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.fleetDetails = data;

          this.fundingSources.forEach(fs => {
            if (fs.credentialfleet && data.fundingSources && data.fundingSources.includes(fs._id)) {
              fs.disabled = true;
            }
          });
          this.fundingSources = [...this.fundingSources]; // refresh the array reference to referesh the view

          this.fleetForm.patchValue(data);
          if(data.los)
          this.onLosChange(data.los)

          if(data.capacities)
          this.addCapacity(data.capacities)
        }
      });
  }

  getEquipments(){
    let queryParams = {
      isAddon: false,
    }
    this.equipment
      .getEquipments(queryParams)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.equipments = data
        }
      });
  }

  onLosChange(losId) {
    this.spaceTypes = [];
    if (!losId) {
      this.fleetForm.patchValue({
        spaceType: '',
        losDetails: {
          title: '',
          profileImageURL: ''
        }
      });
      return;
    };

    const losName = this.levelOfServices.find((los) => los._id === losId);
    if (losName) {
      this.fleetForm.patchValue({
        losDetails: {
          title: losName.title,
          profileImageURL: losName.profileImageURL
        }
      });
    }


    this.spaceTypes = this.spaceTypesMain.filter(item => item.los === losId);
    const spaceTypes = this.spaceTypes.filter(spaceTypeItem => spaceTypeItem._id === this.fleetForm.value.spaceType);
    if (!spaceTypes.length) {
      this.fleetForm.patchValue({
        spaceType: '',
      });
    }

  }

  onSpaceTypeChange(event) {
    if (!event) {
      this.fleetForm.patchValue({
        spaceTypeDetails: {
          title: ''
        }
      });
      return;
    };

    const spaceTypeName = this.spaceTypesMain.find((spaceType) => spaceType._id === event);
    if (spaceTypeName) {
      this.fleetForm.patchValue({
        spaceTypeDetails: {
          title: spaceTypeName.title
        }
      })
    }
  }

  getAddress(place) {
    this.fleetForm.patchValue({
      owner: {
        address: place.formatted_address,
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      },
    });
  }

  addCapacity(preCapacityList?){

    const items = this.fleetForm.get('capacities') as UntypedFormArray;

    if (preCapacityList) {
      for (const capacityItem of preCapacityList) {
        if (capacityItem.isDefault) return;
        items.push(
          this.fb.group({
            _id : [capacityItem._id],
            capacity: [capacityItem.capacity,Validators.required],
            spaceType: [ capacityItem.spaceType,Validators.required],
          })
        );

      }
      return;
    }

    items.push (this.fb.group({
      capacity: [ '',Validators.required],
      spaceType: [ '',Validators.required],
    })
    )
  }

  removeCapacity(index: any) {
    const items =  this.fleetForm.get('capacities')as UntypedFormArray;
    items.removeAt(index);
}

  onSubmit() {
    this.isSubmitted = true;
    if (this.fleetForm.invalid) {
      return;
    }
    let payload = this.fleetForm.value;

    // filter all capacities  then update Default capacity
    payload.capacities.push({
      isDefault: true,
      capacity:payload.capacity,
      spaceType: payload.spaceType
    })

    if (!this.equipments.length) {
      delete payload.equipments;
    }
    if (!this.serviceAreas.length) {
      delete payload.serviceAreas;
    }
    if (!payload.serviceAreas) {
      delete payload.serviceAreas;
    }
    if (!payload.equipments) {
      delete payload.equipments;
    }

    this.fleetService
      .addFleet(payload, this.fleetId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data && !data.success && data.message) {
          sweetAlert('Error', data.message, 'warning', 'OK');
        } else if (data) {
          this.router.navigateByUrl('/fleet/vehicles')
        } else {
          sweetAlert('Error', data.message, 'warning', 'OK');
        }
      });
  }

  get form() {
    return this.fleetForm.controls;
  }

  get dimensions() {
    return this.fleetForm.controls.dimensions;
  }

  get capacitiesForm() {
    return this.fleetForm.get('capacities') as UntypedFormArray;
  }

  selectAllFundingSource(isEnabled) {
    const savedFundingSources = this.fleetDetails && this.fleetDetails.fundingSources && this.fleetDetails.fundingSources.length ? this.fleetDetails.fundingSources : undefined;

    let selectedFundingSource = [];
    if (!isEnabled) {
      for (let fundingSource of this.fundingSources) {
        if (fundingSource.credentialfleet) {
          if (!(savedFundingSources && savedFundingSources.includes(fundingSource._id))) {
            continue;
          }
        };
        selectedFundingSource.push(fundingSource._id)
      }
      _.uniq(selectedFundingSource).sort();
    } else {
      if (this.fleetDetails && this.fleetDetails.fundingSources && this.fleetDetails.fundingSources.length) {
        const fundingSources = this.fleetDetails.fundingSources;
        fundingSources.forEach(fsId => {
          const preFS = this.preFundingSources[fsId];
          if (preFS.credentialfleet) {
            selectedFundingSource.push(fsId);
          }
        });
      }
    }

    this.fleetForm.patchValue({
      fundingSources: selectedFundingSource
    });
  }


  selectAllCapacities(isEnabled){
    let items = this.fleetForm.get('capacities') as UntypedFormArray;
    if (!isEnabled) {
      for (let spaceTypeItem of this.spaceTypeCapacity){

        const exists = items.controls.some(control => {
          return control.value.spaceType === spaceTypeItem._id;
        });

        if(exists){
          continue;
        }

        items.push(this.fb.group({
          capacity: ['1',Validators.required],
          spaceType: [ spaceTypeItem._id,Validators.required],
        }));

      }
    }else{
      items.clear();
    }

  }

  selectAllServiceAreas(isEnabled) {

    let selectedServiceAreas = [];
    if (!isEnabled) {
      for (let serviceArea of this.serviceAreas) {
        selectedServiceAreas.push(serviceArea._id)
      }
      _.uniq(selectedServiceAreas).sort();
    }

    this.fleetForm.patchValue({
      serviceAreas: selectedServiceAreas
    });
  }

  ngOnDestroy(): void {}
}
